export const PROVINCES = [
    { short: "AL", long: "Alabama" },
    { short: "AK", long: "Alaska" },
    { short: "AS", long: "American Samoa" },
    { short: "AZ", long: "Arizona" },
    { short: "AR", long: "Arkansas" },
    { short: "CA", long: "California" },
    { short: "CO", long: "Colorado" },
    { short: "CT", long: "Connecticut" },
    { short: "DE", long: "Delaware" },
    { short: "DC", long: "District Of Columbia" },
    { short: "FM", long: "Federated States Of Micronesia" },
    { short: "FL", long: "Florida" },
    { short: "GA", long: "Georgia" },
    { short: "GU", long: "Guam" },
    { short: "HI", long: "Hawaii" },
    { short: "ID", long: "Idaho" },
    { short: "IL", long: "Illinois" },
    { short: "IN", long: "Indiana" },
    { short: "IA", long: "Iowa" },
    { short: "KS", long: "Kansas" },
    { short: "KY", long: "Kentucky" },
    { short: "LA", long: "Louisiana" },
    { short: "ME", long: "Maine" },
    { short: "MH", long: "Marshall Islands" },
    { short: "MD", long: "Maryland" },
    { short: "MA", long: "Massachusetts" },
    { short: "MI", long: "Michigan" },
    { short: "MN", long: "Minnesota" },
    { short: "MS", long: "Mississippi" },
    { short: "MO", long: "Missouri" },
    { short: "MT", long: "Montana" },
    { short: "NE", long: "Nebraska" },
    { short: "NV", long: "Nevada" },
    { short: "NH", long: "New Hampshire" },
    { short: "NJ", long: "New Jersey" },
    { short: "NM", long: "New Mexico" },
    { short: "NY", long: "New York" },
    { short: "NC", long: "North Carolina" },
    { short: "ND", long: "North Dakota" },
    { short: "MP", long: "Northern Mariana Islands" },
    { short: "OH", long: "Ohio" },
    { short: "OK", long: "Oklahoma" },
    { short: "OR", long: "Oregon" },
    { short: "PW", long: "Palau" },
    { short: "PA", long: "Pennsylvania" },
    { short: "PR", long: "Puerto Rico" },
    { short: "RI", long: "Rhode Island" },
    { short: "SC", long: "South Carolina" },
    { short: "SD", long: "South Dakota" },
    { short: "TN", long: "Tennessee" },
    { short: "TX", long: "Texas" },
    { short: "UT", long: "Utah" },
    { short: "VT", long: "Vermont" },
    { short: "VI", long: "Virgin Islands" },
    { short: "VA", long: "Virginia" },
    { short: "WA", long: "Washington" },
    { short: "WV", long: "West Virginia" },
    { short: "WI", long: "Wisconsin" },
    { short: "WY", long: "Wyoming" }
];


// WEBPACK FOOTER //
// /root/anvel/angular/app/data/provinces.ts